import axios from 'axios';
import API_BASE_URL from '../config';


const logsUserService = async (user, action, token) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        await axios.post(`${API_BASE_URL}api/log-user/`, {
            user,
            action
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Utiliza el token proporcionado como argumento
                },
            });
    } catch (error) {
        throw new Error(error);
    }
}

export default logsUserService;